import { useContext } from "react";
import RefDataContext from "../contexts/RefDataContext";

export function useRefDataContext() {
    return useContext(RefDataContext);
}